import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/OrdenVenta/ventainterna';
import ListaOrdenes from './VInternoGrid';

const mstp = state => {
    return {...state.ventainterna, permisos: state.login.me.permisos, me: state.login.me}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ListaOrdenes)
